module.exports = __webpack_public_path__ + "img/User.51b0e6be.svg";